module.exports = function () { /* empty */ };



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/_add-to-unscopables.js
 ** module id = 964
 ** module chunks = 0
 **/